import { cn } from "@/lib/utils";
import { useLanguage } from "../i18n";

export interface ProbabilityDisplayProps {
  probability: number;
  size?: "default" | "compact";
  className?: string;
}

export function ProbabilityDisplay({ probability, size = "default", className }: ProbabilityDisplayProps) {
  const { t } = useLanguage();
  const percentage = (probability * 100).toFixed(1);

  if (size === "compact") {
    return (
      <div className={cn("text-center", className)}>
        <div
          className={cn(
            "font-display text-4xl sm:text-5xl leading-none",
            "bg-gradient-to-b from-bb-bone-white to-bb-gold",
            "bg-clip-text text-transparent"
          )}
        >
          {percentage}%
        </div>
      </div>
    );
  }

  return (
    <div className={cn("text-center", className)}>
      <div
        className={cn(
          "font-display text-[clamp(4rem,15vw,8rem)] leading-none",
          "bg-gradient-to-b from-bb-bone-white to-bb-gold",
          "bg-clip-text text-transparent"
        )}
      >
        {percentage}%
      </div>
      <div
        className={cn(
          "font-condensed text-xl uppercase tracking-[0.2em]",
          "text-bb-gold mt-2"
        )}
      >
        {t.totalProbability}
      </div>
    </div>
  );
}
